import { computed, unref, watchEffect } from "vue";
import { useSeoMatic } from "../seo/seomatic/useSeomatic.mjs";
import { useHead, showError } from "#imports";
export function useCraftPage({ error, data, status }, entryKey = "entry", applySeomatic = true) {
  const craftEntry = computed(() => {
    return data?.value?.[entryKey];
  });
  if (applySeomatic) {
    const craftSeoData = computed(() => {
      return craftEntry.value?.seomatic;
    });
    const seoData = useSeoMatic(craftSeoData);
    useHead(seoData);
  }
  watchEffect(() => {
    if (status.value === "pending") {
      return;
    }
    if (!craftEntry?.value && unref(error)) {
      showError({
        statusCode: error.value?.statusCode || -1,
        statusMessage: error.value?.statusMessage || "Internal server error",
        message: error.value?.toString()
      });
    } else if (!craftEntry?.value) {
      showError({ statusCode: 404, statusMessage: "Page Not Found" });
    }
  });
  return {
    craftEntry
  };
}
